import React from 'react'
import useError from '@vero/ui-core-browser/hooks/error.js'
import ErrorPage from '@vero/ui-components/pages/error.jsx'

export default function () {
  const { useRouteError } = useError()
  const error = useRouteError()

  return (
    <ErrorPage error={error} />
  )
}
